import './scripts/common';
import './scripts/common-nav';

import {onFind} from "@elements/init-modules-in-scope";

let _config = window['_config'] || {};

let app = {
    debug: false,
};
window.app = app || {};

// Todo: Add page specific JS here e.g:
import * as lightbox from '@elements/lightbox';

lightbox.init();

import * as hoverImages from './scripts/hover-images';

hoverImages.init();

import Tab from 'bootstrap/js/dist/tab';

onFind('[data-toggle="tab"]', function (element) {
    new Tab(element);
});

import * as parallax from './scripts/parallax';

parallax.initInScope();

import * as slideOnScroll from './scripts/slide-on-scroll';

slideOnScroll.initInScope();
import {translate} from '@elements/translations';

function dotsDefaultRenderFunction(id = null, dotContainer, options) {
    let dotThumbsArray = dotContainer.dataset.thumbSrc.split(",");
    let dotThumbTypesArray = dotContainer.dataset.thumbType.split(",");
    let ariaLabel = translate('slider.image-item');
    let markupElement = document.createElement('div'),
        dotMarkup = `<div class="js-dot-slider__item"><button type="button" aria-label="${ariaLabel}" class="hero-product-slider__dot scrolling-area__item ratio ratio-1x1 js-scroll-slider__dots-btn ${id === 0 ? 'is-active' : ''}">
                                <img fetchpriority="low" class="js-lazy-img ratio-item object-fit-contain" src="${dotThumbsArray[id]}" alt="">
                            </button></div>`;
    if (dotThumbTypesArray[id]) {
        dotMarkup = `<div class="js-dot-slider__item"><button type="button" aria-label="${ariaLabel}" class="hero-product-slider__dot scrolling-area__item ratio ratio-1x1 js-scroll-slider__dots-btn ${id === 0 ? 'is-active' : ''}">
                                <div class="video-overlay__play-button video-overlay__play-button--small">
                                    <span class="icon icon-play video-overlay__icon" aria-label="Play Video" title="Play Video"></span>
                                </div>
                                <img fetchpriority="low" class="js-lazy-img ratio-item object-fit-contain" src="${dotThumbsArray[id]}" alt="">
                            </button></div>`;
    }

    markupElement.innerHTML = dotMarkup;
    let newDot = markupElement.childNodes[0];
    dotContainer.appendChild(newDot);

    return newDot;
}

import * as scrollSlider from '@elements/scroll-slider';

scrollSlider.init(
    {
        arrows: false,
        dots: true,
        dotsRenderFunction: dotsDefaultRenderFunction
    },
    {
        base: '.js-hero-product-slider',
        area: '.js-hero-product-slider__area',
        item: '.js-hero-product-slider__item',
        dotsContainer: '.js-hero-product-slider__dots-container'
    }
);

import * as scrollSliderDots from '@elements/scroll-slider';

scrollSliderDots.init(
    {
        arrows: true,
        arrowClass: "hero-portal-slider__arrow",
        arrowPrevClass: "hero-portal-slider__arrow--prev",
        arrowNextClass: "hero-portal-slider__arrow--next",
        arrowIconClass: "icon icon-arrow-right-long",
        dots: false
    },
    {
        base: '.js-dot-slider',
        area: '.js-dot-slider__area',
        item: '.js-dot-slider__item'
    }
);

import * as ajaxForm from '@elements/ajax-form';

ajaxForm.init();

import * as dropdownPersist from './scripts/dropdown-persist';

dropdownPersist.init();

import * as multiSelectDropdown from './scripts/multiselect-dropdown';

multiSelectDropdown.init();

import * as overlayToggle from './scripts/overlay-toggle';

overlayToggle.init();

import * as numberSpinner from '@elements/number-spinner';

numberSpinner.init();

import * as linkInputs from './scripts/link-inputs';

linkInputs.init();

import * as imageSlider from './scripts/image-slider';

imageSlider.init();

import * as scrollFunctions from './scripts/scroll-functions';

scrollFunctions.init();

import * as countCartItems from './scripts/count-cart-items';

countCartItems.init();

import * as wishlist from './scripts/wishlist';

wishlist.init();

//import * as productSuccessModal from './scripts/product-success-modal';
//productSuccessModal.init();

import * as playVideo from './scripts/play-video';

playVideo.init();

import * as ajaxModal from './scripts/ajax-modal';

ajaxModal.init();

import {createApp} from 'vue';
import tooltipDirective from "./scripts/checkout/directives/tooltip/";

onFind('.vue-initialize-module', function (element) {

    let componentModule = element.dataset.initializeModule || false;
    if (componentModule) {
        let vueApp = createApp({});
        const getModule = () => import(`./scripts/checkout/templates/${componentModule}.vue`);
        getModule()
            .then(function (moduleName) {
                vueApp.component(componentModule, moduleName.default);
                console.log('vueApp', vueApp);
                tooltipDirective(vueApp);
                vueApp.mount(element);
            }).catch(function (evt) {
            console.error(evt);
        })
    }
});

import * as actionChanger from "@elements/action-changer";

actionChanger.init();

import * as openCartSidebar from "./scripts/open-cart-sidebar";

openCartSidebar.init();

import * as popperJS from "./scripts/libs/popper";

popperJS.init();

import * as initPopovers from "./scripts/init-popovers";

initPopovers.init();

import * as formValidation from '@elements/form-validation';

formValidation.init();

import * as affix from "@elements/affix";
/*Ugly fix (Media Queries are not working here - I don't know why)*/
affix.init({
    offset: -500,
    breakpoints: {
        768: {
            offset: 160,
        },
    }
});

import * as closeAccordion from "./scripts/close-accordion";

closeAccordion.init();
